import React, { useEffect, useState } from "react";
import './style.css';
import SlideShowGalleryDetail from "../../Common/Component/SlideShowGalleryDetail";
import detailSample from '../../images/detailSample.png';


export default function DetailPage({  match, action, MenuArray }) {
    const [detailItem, setDetailItem] = useState();
    const [productId , setProductId] = useState();
    const [init , setInit] = useState(false);
    const getViewItem = (product_id) => {
        fetch(`/shoping/getViewItem?product_id=${product_id}`, { credentials: 'include' })
            .then((res) => res.json())
            .then((msg) => setDetailItem(msg))
            .catch(err => alert('Error' + err));
    }

    const handleItemDelete = (product_id) => {
        fetch(`/shoping/itemDelete`, {
          method: 'POST',
          mode:'cors',
          credentials:'include',
          headers: { 'Content-Type': 'application/json' }, // Content-Type 헤더 추가
          body: JSON.stringify({ product_id })
        })
        .then((res) => res.json())
        .then((msg) => {
          console.log(msg);
        })
        .catch(err => alert('Error' + err));
      }
                

    useEffect(() => {
        const productId = match.params.product_id;
        setProductId(productId)
        getViewItem(productId);
        var Data = { "NUM": productId, "NOTICE_NAME": "", "NOTICE_TEXT": "" };

        // action.InitializeScreen(props, Data, MenuArray);
    }, []);
   

    if(detailItem && detailItem.length!==0){
    return (
        <div className="detailPage">
            <section className="itemInfo">
                <SlideShowGalleryDetail />
                <div className="itemInfoBox">
                    <hr className="hrStyleHead" />
                    <p>상품명 : {detailItem[0].product_name}</p>
                    <strong className="infoTitle"></strong>
                    <p id="modelNum"></p>
                    <p id="originPrice">가격 : {detailItem[0].product_price} 원</p>
                    <p id="itemPrice"></p>
                    <hr className="hrStyle" />
                    <div class="select-container">
                        <span id="optionSelect">옵션선택</span>
                        <select className="size-select">
                            <option value="" disabled selected>Size </option>
                            <option value="1">Small</option>
                            <option value="2">Medium</option>
                            <option value="3">Large</option>
                        </select>
                    </div>
                    <hr className="hrStyle" />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                        <button id="delBtn" onClick={() => { console.log(productId + "product_id!!"); handleItemDelete(productId) }}>X</button>
                        <div>{productId}</div>
                    </div>

                    <div className="btngroup">
                        <button className="cartBtn">장바구니</button>
                        <button className="buyBtn">구매하기</button>
                    </div>
                </div>
            </section>
            <hr className="hrStyle" />

            <div className="detailPage">
                <img style={{ width: '1200px', margin: '0rem 10rem' }} src={detailSample} />
            </div>
        </div>
    );
}
else{
    return (<>{JSON.stringify(detailItem)}</>)
}
}